import { ContactCreationRequestDto } from '@/api/generated';
import { CreateContactFormModelInner } from '@/views/contactsCreate/model/CreateContactForm.model.ts';

export const mapToContactCreationRequestDto = (
  data: CreateContactFormModelInner,
): ContactCreationRequestDto => {
  const { customer, ...rest } = data;
  if (!data.contactOwnerId) {
    throw new Error('Contact owner not selected');
  }
  return {
    ...rest,
    companyPosition: data.companyPosition ?? undefined,
    contactOwnerId: data.contactOwnerId.value,
    name: data.displayName,
    note: data.note ?? undefined,
    status: data.status.value,
  };
};
